import { render, staticRenderFns } from "./TaskTakeTimeDistribution.vue?vue&type=template&id=965ebbae&scoped=true"
import script from "./TaskTakeTimeDistribution.vue?vue&type=script&lang=js"
export * from "./TaskTakeTimeDistribution.vue?vue&type=script&lang=js"
import style0 from "./TaskTakeTimeDistribution.vue?vue&type=style&index=0&id=965ebbae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965ebbae",
  null
  
)

export default component.exports